import { useForm } from "react-hook-form";
import { FaAngleRight } from "react-icons/fa6";
import "./top-client-pass-form.css";
import axios from "axios";
import Swal from "sweetalert2";
import { modalService } from "../../../components/heavy-header/heavy-header-service";

function TopClientPassForm({ onSuccess }) {

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted }
  } = useForm({
    defaultValues: {
      password: ""
    }
  });

  const handleTopClientPassword = async (data) => {
    try {
      const body = {"password": data.password};
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/setter/top_client_auth`;

      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`
        },
      });
      if(response.data.code === 1) {
        modalService.close();
        if (onSuccess) onSuccess("top");
      }
    } catch (error) {
      Swal.fire({
        title: "Contraseña incorrecta",
        icon: "error",
        confirmButtonColor: "#3085d6",
      })
      modalService.close();
      if (onSuccess) onSuccess("normal");
    }
  }

  return(
    <>
      <form
        className="pass-top-client-form"
        autoComplete="off"
        onSubmit={handleSubmit(handleTopClientPassword)}
      >
        <div
          className="heavy-form-group consignee-content"
        >
          <input
            id="password"
            type="password"
            placeholder=" "
            className="formInput"
            defaultValue=" "
            autoComplete="new-password"
            {...register("password", {
              required: true
            })}
          />
          <label htmlFor="password" className="formLabel">
            Contraseña<span className="text-alert">*</span>
          </label>
          {errors.password?.type === "required" && isSubmitted && (
            <p>Este campo es requerido</p>
          )}
        </div>

        <div className="cont-btn-pass">
          <button>
            Siguiente <FaAngleRight />
          </button>
        </div>
      </form>
    </>
  )
}

export default TopClientPassForm;